var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-line-icons:plus",
    clipPath: "url(#clip0_1279_2289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3372 0C9.27094 0 0.299805 8.97113 0.299805 20.0374C0.299805 31.1044 9.27094 40.0749 20.3372 40.0749C31.4042 40.0749 40.3747 31.1044 40.3747 20.0374C40.3747 8.97113 31.4042 0 20.3372 0ZM20.3372 37.6096C10.6698 37.6096 2.80448 29.7049 2.80448 20.0374C2.80448 10.3699 10.6698 2.5046 20.3372 2.5046C30.0047 2.5046 37.87 10.37 37.87 20.0374C37.87 29.7047 30.0047 37.6096 20.3372 37.6096ZM29.1036 18.7851H21.5896V11.2711C21.5896 10.5798 21.0285 10.0187 20.3372 10.0187C19.6459 10.0187 19.0849 10.5798 19.0849 11.2711V18.7851H11.5709C10.8796 18.7851 10.3185 19.3461 10.3185 20.0374C10.3185 20.7287 10.8796 21.2898 11.5709 21.2898H19.0849V28.8038C19.0849 29.4951 19.6459 30.0561 20.3372 30.0561C21.0285 30.0561 21.5896 29.4951 21.5896 28.8038V21.2898H29.1036C29.7949 21.2898 30.356 20.7287 30.356 20.0374C30.356 19.3461 29.7949 18.7851 29.1036 18.7851Z",
    fill: "#213867"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_2289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.0749,
    height: 40.0749,
    fill: "white",
    transform: "translate(0.299805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.6ee84c531fed0bbe9875f38147c50c5d.svg";
export { ForwardRef as ReactComponent };